import Vue from 'vue'
import {
    TFEvents,
    InitStoreParams,
    AttachStoreToBundleParams,
    SEBundle,
    InitStore,
    AttachStoreToBundle,
} from './types/types'


const store: InitStore = (initStoreParams: InitStoreParams) => {
    const bundle: SEBundle = initStoreParams.bundle
    const events: TFEvents = initStoreParams.events

    const attachStoreToBundle: AttachStoreToBundle = (attachStoreToBundleParams: AttachStoreToBundleParams) => {
        bundle.store = new Vue({
            data: {
                libs: {
                    se: null
                },
                requestOptions: () => {
                    return {
                        urls: attachStoreToBundleParams.urls,
                        headers: {
                            'Accept-Language': attachStoreToBundleParams.locale || 'fr-FR'
                        }
                    }
                },
                ...attachStoreToBundleParams,
                data: {
                    ...(attachStoreToBundleParams.data || {}),
                    geoData: {
                        countries: [],
                        regions: [],
                        regionsMap: {},
                        domains: [],
                        domainsMap: {},
                        parentStations: [],
                        parentStationsMap: {},
                        stations: [],
                        stationsMap: {}
                    },
                    available: {
                        regions: {},
                        regionsMap: {},
                        domains: {},
                        domainsMap: {},
                        parentStations: {},
                        parentStationsMap: {},
                        stations: {},
                        stationsMap: {},
                        capacity: [],
                        capacityMap: {}
                    },
                    selected: {
                        // geo
                        region: null,
                        domain: null,
                        poi: null,
                        parentStations: null,
                        parentStationsMap: {},
                        stations: null,
                        stationsMap: {},

                        // dates
                        startDate: null,
                        endDate: null,

                        capacity: null,
                        autocompleteValue: null
                    }
                },
                state: {
                    ...(attachStoreToBundleParams.state || {}),
                    updateCounters: 0,
                    updateFilters: 0,
                    loading: true,
                    summer: attachStoreToBundleParams.summer,
                    locale: attachStoreToBundleParams.locale,
                    showNextSeasonButton: false
                }
            }
        })
        events.fire('store')
    }

    return attachStoreToBundle
}
export default store
